import { render, staticRenderFns } from "./MediaBox.vue?vue&type=template&id=113e99e2&scoped=true&"
import script from "./MediaBox.vue?vue&type=script&lang=js&"
export * from "./MediaBox.vue?vue&type=script&lang=js&"
import style0 from "./MediaBox.vue?vue&type=style&index=0&id=113e99e2&prod&lang=css&"
import style1 from "./MediaBox.vue?vue&type=style&index=1&id=113e99e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e99e2",
  null
  
)

export default component.exports